
import { request } from '@/config/request/interceptors'
import type { Commit, Dispatch } from 'vuex'

export default {
  namespaced: true,
  state: {
    canUseNum: 0
  },
  getters: {
    getCanUseNum (state:any) {
      return state.canUseNum
    }
  },
  mutations: {
    SET_CANUSER_NUM: (
      state:any,
      num: number
    ): void => {
      state.canUseNum = num
    }
  },
  actions: {
    async getCanUseNum (store: any) {
      const { commit, dispatch, state, rootState } = store
      if (!rootState.route.curShop) return
      const res = await request.market.coupon.couponCustomerPage({ pageNum: 1, pageSize: 10, buType: 2, usedStatus: 0, couponType: 3 })
      commit('SET_CANUSER_NUM', res.data?.total ?? 0)
    }
  }
}
